import { navigate } from '../../app/navigation';
import { isJurisdictionCode, JURISDICTION_CODE_ORDER } from '../../domain/jurisdiction';
import type { V2Inspection } from '../../domain/inspection';
import { useT } from '../../i18n/i18n';
import { aiBlockFix } from '../../state/aiStore';
import { setPropertyJurisdictionAction } from '../../state/inspectionStore';
import { Button, Field } from '../../ui/components';

// The way out of an AI block, right under the reason on an AI card (Owner 2026-10-07: 「去签协议」).
//   - the agreement is not signed / not consented / an older copy → 去签协议 opens the inspection's
//     details on the Inspection Agreement;
//   - a Demo whose property is not an asserted New York property → the state is chosen here, in place
//     (a Demo never passes the formal-workflow card where a client inspection answers it).
// Every other block renders nothing: it is not the inspector's to clear from an AI card.
export function AiBlockFix(props: { inspection: V2Inspection; reason: string | null; testId: string }) {
  const { t } = useT();
  const fix = aiBlockFix(props.reason);
  if (fix === 'agreement') {
    return (
      <Button variant="secondary" icon="draw" onClick={() => navigate({ screen: 'inspectionDetails', inspectionId: props.inspection.id, focus: 'agreement' })} testId={`${props.testId}-agreement`}>
        {t('ai.fix.agreement')}
      </Button>
    );
  }
  if (fix === 'state') {
    const property = props.inspection.property;
    return (
      <Field label={t('ai.fix.property')} htmlFor={`${props.testId}-state`}>
        <select
          id={`${props.testId}-state`}
          className="field-input"
          value={isJurisdictionCode(property.state) && property.stateConfirmed ? property.state : ''}
          onChange={(event) => void setPropertyJurisdictionAction(props.inspection.id, { state: isJurisdictionCode(event.target.value) ? event.target.value : '' })}
          data-testid={`${props.testId}-state`}
        >
          <option value="">{t('profile.selectState')}</option>
          {JURISDICTION_CODE_ORDER.map((code) => (
            <option key={code} value={code}>
              {code}
            </option>
          ))}
        </select>
      </Field>
    );
  }
  return null;
}
